<div class="content" [ngClass]="{'on': this._syncService.status}">
    <div class="overlay"></div>
    <div class="box">
        <div class="loader">
            <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
        {{ this._syncService.text }}
    </div>
</div>
